<script setup lang="ts">
defineOptions({
  name: 'Ui2CompanyAudio',
});

defineProps({
  title: {
    type: String,
    default: '',
  },
  subTitle: {
    type: String,
    default: '',
  },
  headline: {
    type: String,
    default: '',
  },
  fileUrl: {
    type: String,
    required: true,
  },
  captionsFile: {
    type: String,
    default: '',
  },
  subtitlesFile: {
    type: String,
    default: '',
  },
});
</script>

<template>
  <div v-if="fileUrl" class="ui-audio__wrapper">
    <div class="ui-audio">
      <div v-if="title" class="ui-audio__title">{{ title }}</div>
      <div v-if="subTitle" class="ui-audio__sub-title">{{ subTitle }}</div>
      <div v-if="headline" class="ui-audio__headline">{{ headline }}</div>
      <audio
        class="ui-audio__audio"
        controls
        :src="fileUrl"
        :aria-label="`${[title, subTitle, headline].filter(Boolean).join('. ')}`"
      >
        <track v-if="captionsFile" kind="captions" :src="captionsFile" />
        <track v-if="subtitlesFile" kind="subtitles" :src="subtitlesFile" />
      </audio>
    </div>
  </div>
</template>

<style lang="scss">
.ui-audio__wrapper {
  background: #111;
  color: #fff;
  padding: $space-32 0 $space-40 0;
}
.ui-audio {
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 $space-16;
  display: flex;
  flex-direction: column;
  gap: $space-16;
  align-items: center;
}

.ui-audio__title,
.ui-audio__sub-title,
.ui-audio__headline {
  max-width: 350px;
  text-align: center;
}

.ui-audio__title {
  @include v2-text-style('2xl', highlight);
}

.ui-audio__headline {
  @include v2-text-style('lg', highlight);
}

.ui-audio__audio {
  width: 100%;
  max-width: 700px;
  height: 40px;
}
</style>
